import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { ReactSelectInput } from '@hivebrite/design-system/Inputs';

import {
  getSubnetworkOptions,
  getDefaultSubnetworkPlaceholder,
} from '../utils/subnetworkOptions';

const ReactSelectSubnetworks = ({
  options = [],
  placeholder,
  isNotSearchable,
  ...props
}) => {
  const availableOptions = isEmpty(options) ? getSubnetworkOptions() : options;

  return (
    <ReactSelectInput
      options={availableOptions}
      placeholder={placeholder || getDefaultSubnetworkPlaceholder()}
      isNotSearchable={isNotSearchable ?? availableOptions?.length <= 10}
      {...props}
    />
  );
};

ReactSelectSubnetworks.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.array,
};

export default ReactSelectSubnetworks;
